import { If } from 'aa_common/front-end/components'
import { everyTrue, ifElse, someTrue } from 'aa_common/front-end/helpers'
import { isTaxJournalTarget } from 'common/helpers'
import { HiddenField } from 'components/atoms'
import { AutoCompleteSelect } from 'components/molecules'
import React from 'react'

import { EmptySection, UnderlineText } from '../events/styles'

type LedgerSettingFieldsProps = {
  ledgerSettings: any[]
  endedMethodIndex: number
  convertDataLedgerSettingHelper: (params: any) => any
  assetItem: any
  isEditMode: boolean
  retirementDepreciationEndedMethods: any[]
  hasBothTaxAndAccountingLedgers: boolean
  isRetirementEvent?: boolean
  enablePartialImpair?: boolean
}

export const renderLedgerSettingFields = ({
  ledgerSettings,
  endedMethodIndex: initialEndedMethodIndex,
  convertDataLedgerSettingHelper,
  assetItem,
  isEditMode,
  retirementDepreciationEndedMethods,
  hasBothTaxAndAccountingLedgers,
  isRetirementEvent,
  enablePartialImpair,
}: LedgerSettingFieldsProps) => {
  let endedMethodIndex = initialEndedMethodIndex

  return ledgerSettings?.map((ledgerSetting, index) => {
    const {
      isSelectWhenSellorRetire,
      isEndOfCurrentMonth,
      isEndOfLastMonth,
      datasourceItems,
      isNonDepreciationOrNonTargetMethod,
      isSmallAmountDepreciableAsset,
      isBulkEqualInstallment,
      currentDepreciationMethodContinue,
    } = convertDataLedgerSettingHelper({
      ledgerSetting,
      assetItem,
      isEditMode,
      retirementDepreciationEndedMethods,
      hasBothTaxAndAccountingLedgers,
      enablePartialImpair,
    })

    if (
      someTrue(isEndOfCurrentMonth, isEndOfLastMonth) &&
      someTrue(isSmallAmountDepreciableAsset, isNonDepreciationOrNonTargetMethod)
    ) {
      endedMethodIndex++

      return (
        <div key={ledgerSettings[index].id}>
          <UnderlineText style={{ paddingTop: 32 }} />
          <HiddenField
            name={`retirement_fixed_asset_ledger_requests[${endedMethodIndex}].ledger_setting_id`}
            value={ledgerSettings[index].id}
          />
          <HiddenField
            name={`retirement_fixed_asset_ledger_requests[${endedMethodIndex}].retirement_depreciation_ended_method`}
            value={ledgerSettings[index].retirement_depreciation_ended_method}
          />
        </div>
      )
    }

    if (isSelectWhenSellorRetire) {
      endedMethodIndex++

      if (someTrue(isSmallAmountDepreciableAsset, isNonDepreciationOrNonTargetMethod)) {
        return (
          <div key={ledgerSettings[index].id}>
            <If condition={!isRetirementEvent}>
              <EmptySection />
            </If>
            <If condition={isRetirementEvent}>
              <UnderlineText style={{ paddingTop: 32 }} />
            </If>

            <HiddenField
              name={`retirement_fixed_asset_ledger_requests[${endedMethodIndex}].ledger_setting_id`}
              value={ledgerSettings[index].id}
            />
            <HiddenField
              name={`retirement_fixed_asset_ledger_requests[${endedMethodIndex}].retirement_depreciation_ended_method`}
              value={ledgerSettings[index].retirement_depreciation_ended_method}
            />
          </div>
        )
      }

      return (
        <div key={ledgerSettings[index].id}>
          <If condition={!isTaxJournalTarget?.(ledgerSetting)}>
            <AutoCompleteSelect
              name={`retirement_fixed_asset_ledger_requests[${endedMethodIndex}].retirement_depreciation_ended_method`}
              disabled={everyTrue(currentDepreciationMethodContinue, isBulkEqualInstallment)}
              wrapperStyle={{ marginRight: 10, width: 240, marginTop: 8 }}
              items={datasourceItems}
              valueField="code"
              textField="name_jp"
              allowClear={false}
            />
          </If>
          <If condition={everyTrue(isTaxJournalTarget?.(ledgerSetting) && !isRetirementEvent)}>
            <EmptySection />
          </If>
          <HiddenField
            width={ifElse(isRetirementEvent, '240px', undefined)}
            name={`retirement_fixed_asset_ledger_requests[${endedMethodIndex}].ledger_setting_id`}
            value={ledgerSettings[index].id}
          />
        </div>
      )
    }

    endedMethodIndex++

    return (
      <div key={ledgerSettings[index].id}>
        <UnderlineText style={{ marginRight: 10, height: 36 }}>&nbsp;</UnderlineText>
        <HiddenField
          name={`retirement_fixed_asset_ledger_requests[${endedMethodIndex}].ledger_setting_id`}
          value={ledgerSettings[index].id}
        />
        <HiddenField
          name={`retirement_fixed_asset_ledger_requests[${endedMethodIndex}].retirement_depreciation_ended_method`}
          value={ledgerSettings[index].retirement_depreciation_ended_method}
        />
      </div>
    )
  })
}
